module.exports = __webpack_public_path__ + "static/img/lan.1a7a56b3.png";